export default "__VITE_ASSET__Q0GpRdOY__"